const Warning = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.4112 21.1533L16.2872 7.08182C15.9898 6.56704 15.4406 6.25 14.8462 6.25C14.2518 6.25 13.7026 6.56704 13.4053 7.08182L5.22281 21.2545C4.92573 21.7693 4.92573 22.4034 5.22281 22.9182C5.52012 23.433 6.06936 23.75 6.66375 23.75H23.0289C23.0306 23.75 23.0325 23.75 23.0337 23.75C23.9525 23.75 24.6973 23.0052 24.6973 22.0864C24.6971 21.7406 24.5918 21.4192 24.4112 21.1533Z"
      stroke="white"
    />
    <path
      d="M14.8486 11.1444C15.3619 11.1444 15.7783 11.5606 15.7783 12.0741L15.5406 17.619C15.5169 18.1205 15.1271 18.3111 14.8486 18.3111C14.5365 18.3111 14.1838 18.1466 14.1565 17.619L13.9188 12.0741C13.9188 11.5606 14.3352 11.1444 14.8486 11.1444Z"
      fill="white"
    />
    <path
      d="M15.6875 21.1222C15.4686 21.3432 15.1621 21.4691 14.8486 21.4691C14.5349 21.4691 14.2283 21.3432 14.0073 21.1222C13.7862 20.9011 13.6603 20.5946 13.6603 20.2808C13.6603 19.9671 13.7862 19.6629 14.0073 19.4419C14.2283 19.2209 14.5349 19.0925 14.8486 19.0925C15.1621 19.0925 15.4686 19.2209 15.6875 19.4419C15.9109 19.6629 16.0369 19.9695 16.0369 20.2808C16.0369 20.5946 15.9109 20.9011 15.6875 21.1222Z"
      fill="white"
    />
  </svg>
);

export default Warning;
